export default __webpack_public_path__ + "static/media/deauville20.63677860.jpg";